import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import BankIcon from "../images/piggy_bank_icon.svg";
import AmbassadorOne from "../images/ambassador_icon_1.svg";
import AmbassadorTwo from "../images/heart_icon.svg";
import CardHolder from "../images/landing/rotSection/section_1_image.webp";
import Card from "../images/svg/card.svg";
import PageHeaders from "../common/PageHeaders";
import Menu from "../common/Menu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewValues from "../components/NewValues";
import RotSection from "../components/RotSection";
import YourCardAmbassador from "../components/YourCardAmbassador";
import DotsAndLines from "../components/DotsAndLines";

const success = "success",
  error = "error",
  pending = "pending";

const AmbassadorRequestForm = ({ className, btnDark, ...props }) => {
  const inputStyle = "border rounded-lg p-4 m-2 w-full placeholder-gray-800";

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");

  const [state, setState] = useState();
  const disabled = state === "pending" || state === "success";

  const reset = () => {
    setState();
    setName("");
    setEmail("");
    setPhone("");
    setDescription("");
  };

  return (
    <form
      className={`bg-white shadow-faint w-3/4 mx-auto px-12 py-4 flex flex-col items-center rounded-lg ${className || ""}`}
      onSubmit={async e => {
        e.preventDefault();
        setState(pending);
        axios
          .post("/supportEmail", {
            name,
            subject: "Ambassador request",
            email,
            phone,
            description: `${description}\n\n[phone: ${phone}]`
          })
          .then(() => {
            setState(success);
            setTimeout(() => reset(), 3000);
          })
          .catch(err => {
            console.log("error sending ambassador email", err);
            setState(error);
          });
        return false;
      }}
      {...props}
    >
      <h2 className="text-1xl md:text-2xl font-extrabold m-6">
        Ambassador request form
      </h2>
      <input
        className={inputStyle}
        placeholder="First and last name"
        value={name}
        disabled={disabled}
        onChange={e => {
          setName(e.target.value);
        }}
      />
      <input
        className={inputStyle}
        placeholder="Email"
        value={email}
        disabled={disabled}
        onChange={e => {
          setEmail(e.target.value);
        }}
      />
      <input
        className={inputStyle}
        placeholder="Phone"
        value={phone}
        disabled={disabled}
        onChange={e => {
          setPhone(e.target.value);
        }}
      />
      <textarea
        className={inputStyle}
        placeholder="Please include social media handles and a brief description of why you would be a good ambassador."
        rows={5}
        value={description}
        disabled={disabled}
        onChange={e => {
          setDescription(e.target.value);
        }}
      />
      <input
        type="submit"
        className={`${
          disabled
            ? "bg-gray-300 text-gray-600"
            : btnDark
            ? "bg-primary-dark text-primary-txt cursor-pointer"
            : "bg-primary-btn cursor-pointer"
        } font-bold px-10 py-3 my-5 rounded-md shadow-xl`}
        value="Submit application"
        disabled={disabled}
      />
      <div className="text-sm text-gray-600">
        {state === pending
          ? "Submitting your request..."
          : state === success
          ? <span className="text-primary">Your request was successfully submitted!</span>
          : state === error
          ? "There was an issue with your request. Please try again."
          : false}
      </div>
    </form>
  );
};

const Ambassador = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <PageHeaders type="ambassador" />
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${!!menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={state => {
              setMenuOpen(state.isOpen);
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="mainContent xtopSection" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle={"Become an ambassador"} />
          </div>
          <div className="mainContent flex md:mt-8 lg:mt-24">
            <main className="w-full text-dark pt-16">
              <div className="md:flex max-w-page">
                <div className="flex-1">
                  <div className="w-3/4 mx-auto pt-10">
                    <h1 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold text-primary">
                      Become an ambassador
                      <span class="text-primary-txt">.</span>
                    </h1>
                    <p className="text-lg md:text-xl my-4 text-white">
                      <strong>Get up to 20% cashback!</strong> Apply to become
                      an ambassador today and get 1% bonus cashback for every
                      referral. Limited spots available.
                    </p>
                  </div>
                </div>
                <div className="flex-1 py-16 lg:py-0">
                  <DotsAndLines>
                    <AmbassadorRequestForm />
                  </DotsAndLines>
                </div>
              </div>

              <div className="max-w-page">
                <div className="md:flex pb-10">
                  <div className="px-12 pt-10 w-full md:w-1/2 self-center">
                    <img src={CardHolder}></img>
                  </div>
                  <div className="text-white px-8 md:px-10 xl:px-20 self-center w-full md:w-1/2">
                    <h2 className="font-extrabold text-3xl xl:text-4xl mb-3 tracking-tight md:tracking-normal">
                      Our mission<span className="text-primary-txt">.</span>
                    </h2>
                    <p className="text-lg">
                      Whether you have credit history or not, our mission at
                      Tomo is to make sure everyone has equal opportunity in
                      accessing the spending power they deserve. Do you believe
                      the same? Then you're in the right place!
                    </p>
                  </div>
                </div>
              </div>

              <div className="max-w-page p-10">
                <h2 className="font-extrabold text-2xl md:text-3xl my-3 text-center">
                  Value proposition
                </h2>
                <NewValues
                  vals={[
                    {
                      img: Card,
                      title: "No credit history required",
                      desc:
                        "We assess your financial history and income potential to determine your credit worthiness and have the flexibility to update your spending power in real time."
                    },
                    {
                      img: BankIcon,
                      title: "Build credit & earn cashback",
                      desc:
                        "We set up 7-day autopay to help you build your credit score and earn cashback quickly!"
                    }
                  ]}
                />
              </div>

              <div className="max-w-page">
                <RotSection
                  subtitleContainerClass='text-white'
                  subtitle="Who it's for"
                  title="The breakdown"
                  img={AmbassadorOne}
                  imgWrap
                  shouldUseWhiteText
                  imgProps={{ style: { width: "316px" } }}
                  flip
                >
                  <ul className="bluelist text-white">
                    <li>
                      Tomo is inviting a select group of influencers to be brand
                      ambassadors
                    </li>
                    <li>
                      As an ambassador, you will promote the Tomo card and
                      encourage your community to sign up for one through a
                      unique referral code
                    </li>
                    <li>Perks include a Tomo card and up to 20% cashback</li>
                  </ul>
                </RotSection>
                <RotSection
                  subtitle="The program"
                  title="How it works"
                  img={AmbassadorTwo}
                  imgWrap
                  imgProps={{
                    style: {
                      width: "316px",
                      marginTop: "15px",
                      marginBottom: "-15px"
                    }
                  }}
                  shouldUseWhiteText
                >
                  <ol className="bluelist">
                    <li>
                      For each referral that gets approved, you will earn an
                      additional 1% cashback (valid for
                      3 months)
                    </li>
                    <li>
                      Keep referring and earn up to 20% cashback! Referrals are
                      unlimited
                    </li>
                    <li>
                      You can get up to $500 in cashback each month
                    </li>
                  </ol>
                  Have more questions?{" "}
                  <Link to="/faq" className="text-primary-txt underline">
                    Check out our FAQs
                  </Link>
                </RotSection>
              </div>

              <div className="max-w-page">
                <YourCardAmbassador />
              </div>

              <div className="w-full bg-primary-dark py-20">
                <div className="max-w-page text-white text-center">
                  <h2 className="text-3xl md:text-4xl font-extrabold max-w-md mx-auto">
                    Apply to become an ambassador
                    <span className="text-primary-txt">.</span>
                  </h2>
                  <p className="max-w-xs mx-auto my-6">
                    Fill out the form and start earning up to 20% cashback
                    today!
                  </p>
                  <AmbassadorRequestForm
                    className="text-primary-dark max-w-lg"
                    btnDark
                  />
                  <p className="pt-6">
                    <a
                      href="mailto:ambassador@tomocredit.com"
                      className="text-primary-txt underline"
                    >
                      Contact us
                    </a>
                  </p>
                </div>
              </div>
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Ambassador;
